import api from './api';
import { PaginationInfo } from '../types';

export interface AdminUserSummary {
  id: number;
  username: string;
  email: string;
  role: string;
  is_admin: boolean;
  first_name?: string | null;
  last_name?: string | null;
  created_at?: string | null;
}

export interface AdminUserListResponse {
  users: AdminUserSummary[];
  pagination: PaginationInfo;
}

export const adminUsersService = {
  async list(params: { page?: number; per_page?: number; role?: string; search?: string } = {}): Promise<AdminUserListResponse> {
    const searchParams = new URLSearchParams();
    if (params.page) searchParams.set('page', String(params.page));
    if (params.per_page) searchParams.set('per_page', String(params.per_page));
    if (params.role) searchParams.set('role', params.role);
    if (params.search) searchParams.set('search', params.search);
    const query = searchParams.toString();
  const res = await api.get(`/api/admin/auth/users${query ? `?${query}` : ''}`);
    return res.data;
  },
};
